if (!customElements.get('load-more')) {
  const LoadMore = class extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-load-more-button]');
      if (!this.button) return;

      this.boundHandleClick = this.boundHandleClick || this.handleClick.bind(this);
      this.button.addEventListener('click', this.boundHandleClick);
    }

    disconnectedCallback() {
      if (this.abortController) {
        this.abortController.abort('Load more container removed');
      }
    }

    handleClick(evt) {
      evt.preventDefault();
      if (this.classList.contains('load-more--loading')) return;

      const pageUrl = this.button.href;
      const fetchUrl = new URL(pageUrl);
      fetchUrl.searchParams.set('section_id', this.dataset.sectionId);

      this.classList.add('load-more--loading');
      this.button.setAttribute('aria-busy', 'true');
      this.abortController = new AbortController();

      fetch(fetchUrl, { signal: this.abortController.signal })
        .then((response) => {
          if (!response.ok) {
            throw new Error(response.status);
          }
          return response.text();
        })
        .then((text) => {
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const grid = document.querySelector(`#shopify-section-${this.dataset.sectionId} .collection-listing > .product-grid`);
          const newGrid = doc.querySelector('.collection-listing > .product-grid');
          if (!grid || !newGrid) {
            throw new Error('Product grid not found');
          }

          const newItems = Array.from(newGrid.children);
          this.loadMissingScripts(newItems);
          grid.append(...newItems);

          this.update(doc.querySelector('load-more'));

          const firstLink = newItems[0] && newItems[0].querySelector('a[href]');
          if (firstLink) {
            firstLink.focus({ preventScroll: true });
          }
        })
        .catch((error) => {
          if (error.name === 'AbortError' || this.abortController.signal.aborted) return;
          console.warn(error);
        })
        .finally(() => {
          this.classList.remove('load-more--loading');
          if (this.button) {
            this.button.removeAttribute('aria-busy');
          }
        });
    }

    loadMissingScripts(items) {
      items.forEach((item) => {
        item.querySelectorAll('script[src]').forEach((script) => {
          const src = script.getAttribute('src');
          if (!document.querySelector(`script[src="${src}"]`)) {
            const newScript = document.createElement('script');
            newScript.src = src;
            newScript.defer = true;
            document.head.appendChild(newScript);
          }
          script.remove();
        });
      });
    }

    update(newLoadMore) {
      if (!newLoadMore) {
        this.remove();
        return;
      }

      this.style.setProperty('--load-more-progress', newLoadMore.style.getPropertyValue('--load-more-progress'));
      this.querySelector('[data-load-more-status]').textContent = newLoadMore.querySelector('[data-load-more-status]').textContent;

      const newButton = newLoadMore.querySelector('[data-load-more-button]');
      if (newButton) {
        this.button.href = newButton.getAttribute('href');
        this.querySelector('[data-load-more-label]').textContent = newButton.querySelector('[data-load-more-label]').textContent;
      } else {
        this.button.remove();
        this.button = null;
      }
    }
  };

  window.customElements.define('load-more', LoadMore);
}
